import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import {ReportColumnFilterProps} from '../types/report-editor.types';
import styles from './report-editor.module.scss';

export const ReportColumnFilter = ({field, column, error, disabled, onChange}: ReportColumnFilterProps) => {
  if (!field.canFilter) return <span className={styles.noFilter}>Без фильтра</span>;
  const isDate = field.type === 'date';
  const isBoolean = field.type === 'boolean';
  const inputType = isDate ? 'datetime-local' : 'text';
  return (
    <div className={styles.filter}>
      <TextField
        select
        size="small"
        fullWidth
        label={`Фильтр: ${field.label}`}
        value={column.filterMode}
        disabled={disabled}
        onChange={(event) =>
          onChange({
            ...column,
            filterMode: event.target.value as typeof column.filterMode,
            value: '',
            minValue: '',
            maxValue: '',
          })
        }
      >
        <MenuItem value="none">Без фильтра</MenuItem>
        {!isDate && <MenuItem value="value">Равно / одно из значений</MenuItem>}
        {!isBoolean && <MenuItem value="range">Диапазон</MenuItem>}
      </TextField>
      {column.filterMode === 'value' && (
        <TextField
          size="small"
          fullWidth
          select={isBoolean}
          label={`Значение: ${field.label}`}
          value={column.value}
          disabled={disabled}
          error={Boolean(error)}
          helperText={error || (!isBoolean ? 'Несколько значений — через запятую' : undefined)}
          onChange={(event) => onChange({...column, value: event.target.value})}
        >
          {isBoolean && [
            <MenuItem key="true" value="true">
              Да
            </MenuItem>,
            <MenuItem key="false" value="false">
              Нет
            </MenuItem>,
          ]}
        </TextField>
      )}
      {column.filterMode === 'range' && (
        <>
          <div className={styles.range}>
            <TextField
              size="small"
              fullWidth
              type={inputType}
              label={`От: ${field.label}`}
              value={column.minValue}
              disabled={disabled}
              error={Boolean(error)}
              InputLabelProps={isDate ? {shrink: true} : undefined}
              inputProps={isDate ? {step: 'any'} : undefined}
              onChange={(event) => onChange({...column, minValue: event.target.value})}
            />
            <TextField
              size="small"
              fullWidth
              type={inputType}
              label={`До: ${field.label}`}
              value={column.maxValue}
              disabled={disabled}
              error={Boolean(error)}
              InputLabelProps={isDate ? {shrink: true} : undefined}
              inputProps={isDate ? {step: 'any'} : undefined}
              onChange={(event) => onChange({...column, maxValue: event.target.value})}
            />
          </div>
          {(error || isDate) && (
            <span className={error ? styles.fieldError : styles.filterHint}>
              {error || 'Укажите «От». Время в вашем часовом поясе.'}
            </span>
          )}
        </>
      )}
      {column.filterMode === 'none' && error && <span className={styles.fieldError}>{error}</span>}
    </div>
  );
};
